import type { MaterialId } from "src/api";

import { AllIcons } from "./ui/icons/iconTypes";

export const LIGHT_TILE_COLOR = "#b2a997";
export const DARK_TILE_COLOR = "#575046";
export const TILE_THICKNESS = 0.5;
export const TILE_ROUGHNESS = 0.85;

// TODO: placeholder colors until each material's pixel art is imported
export const MATERIAL_DISPLAY: Record<
  MaterialId,
  { label: string; color: string; icon?: AllIcons }
> = {
  iron: { label: "Iron", color: "#a0a4ab", icon: "res_iron" },
  steel: { label: "Steel", color: "#5f7fa3" },
  "crucible-steel": { label: "Crucible Steel", color: "#c0563a", icon: "res_copper" },
  cobble: { label: "Cobble", color: "#7a6f62" },
  stone: { label: "Stone", color: "#b8ad98" },
  marble: { label: "Marble", color: "#f2efe8" },
  electrum: { label: "Electrum", color: "#e0c04a", icon: "res_gold" },
  diamond: { label: "Diamond", color: "#6fe3f0", icon: "res_diamond" }
};
